import ApiBundleManagement from "./ApiBundleManagement";
import { connect } from "react-redux";
import { actions } from "./apiBundleManagementActions";

export default connect(
  state => ({ ApiBundleManagementReducer: state.ApiBundleManagementReducer }),
  actions
)(ApiBundleManagement);